/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let NotesO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M853.332992 853.332992v-625.77664h-113.77664V256c0 15.709184-12.735488 28.444672-28.445696 28.444672-15.70816 0-28.443648-12.735488-28.443648-28.444672v-28.444672H341.332992V256c0 15.709184-12.734464 28.444672-28.443648 28.444672-15.710208 0-28.444672-12.735488-28.444672-28.444672v-28.444672H170.667008v625.777664h682.665984z m-113.77664-682.665984h113.77664c31.460352 0 56.889344 25.428992 56.889344 56.88832v625.777664c0 31.460352-25.428992 56.889344-56.889344 56.889344H170.667008c-31.460352 0-56.889344-25.428992-56.889344-56.889344v-625.77664c0-31.460352 25.428992-56.889344 56.889344-56.889344h113.77664v-28.444672c0-15.709184 12.735488-28.444672 28.445696-28.444672 15.70816 0 28.443648 12.735488 28.443648 28.444672v28.444672h341.334016v-28.444672c0-15.709184 12.734464-28.444672 28.443648-28.444672 15.710208 0 28.444672 12.735488 28.444672 28.444672v28.444672zM312.88832 625.77664c-15.710208 0-28.444672-12.734464-28.444672-28.444672 0-15.70816 12.734464-28.443648 28.444672-28.443648h398.221312c15.710208 0 28.444672 12.734464 28.444672 28.443648 0 15.710208-12.734464 28.444672-28.444672 28.444672H312.889344z m0-113.777664c-15.710208 0-28.444672-12.735488-28.444672-28.444672s12.734464-28.444672 28.444672-28.444672h398.221312c15.710208 0 28.444672 12.735488 28.444672 28.444672S726.820864 512 711.110656 512H312.889344z m0 227.555328c-15.710208 0-28.444672-12.734464-28.444672-28.444672 0-15.70816 12.734464-28.443648 28.444672-28.443648h170.665984c15.709184 0 28.444672 12.734464 28.444672 28.443648 0 15.710208-12.735488 28.444672-28.444672 28.444672H312.889344z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

NotesO.defaultProps = {
  size: 18,
};

NotesO = React.memo ? React.memo(NotesO) : NotesO;

export default NotesO;
